// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDkt9FLHVSNiYoxfh-St4Pbg-FtqAOUxgE",
  authDomain: "mimarliksolo.firebaseapp.com",
  projectId: "mimarliksolo",
  storageBucket: "mimarliksolo.appspot.com",
  messagingSenderId: "168759120043",
  appId: "1:168759120043:web:f9b9e59623b525100de7ee"
};


export const projectName = "Solo Architects"

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);